import React from 'react';

export const eiapSave = 'eiap-save';

export const REGION_DISPLAY_NAMES = {
    AUSTRALIA_EAST: 'Australia East',
    SOUTHEAST_ASIA: 'Southeast Asia',
};

export const ERROR_MESSAGES = {
    SAM_UNIX_ID_GROUP_NOT_AVAILABLE: 'The provided SAM UNIX ID and Group are not available.',
    SAM_UNIX_ID_GROUP_AVAILABLE: 'The provided SAM UNIX ID and Group are available.',
};

export const COST_CENTER_H_TOOLTIP_TEXT =
    "The 'H-' based cost centers/budget codes have been deprecated. Please use the latest budget codes for the project where you are deploying resources.";

export const COST_CENTER_H_PREFIX_HELPER_TEXT = (
    <>
        {
            "The 'H' and 'H-' prefixes are not allowed. Please enter the value without the 'H' and 'H-' prefixes. For more details, refer to the tooltip information or contact us at "
        }
        <a href="mailto:dl-globalcmpoperations@pepsico.com">dl-globalcmpoperations@pepsico.com</a>
    </>
);

export const COST_CENTER_VALIDATE_HELPER_TEXT = 'Please click the Validate button to validate your cost center before proceeding with the order submission.';

// Message constants
export const COMING_SOON_MESSAGE = 'Coming Soon';
export const START_PROVISIONING_MESSAGE = 'Start Provisioning';

export const SAP_ENVIRONMENT = {
    PRE_PROD: 'Preprod',
    PRODUCTION: 'Production',
};

export const SAP_REGION = {
    UK_SOUTH: 'uksouth',
    SOUTH_CENTRAL_US: 'southcentralus',
};

export const OWNER_TYPES = {
    APPLICATION_OWNER: 'Application Owner',
    ACTIVE_DIRECTORY_GROUP_OWNER: 'Active Directory Group Owner',
    SERVICE_ACCOUNT_OWNER: 'Service Account Owner',
    ADO_OWNER: 'ADO Owner',
};

export const MODIFY_REQUEST_TYPES = {
    REMOVE_MEMBERS: 'Remove Members',
    ADD_MEMBERS: 'Add Members',
};

export default {};
